"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _EditAccessoryComponent = _interopRequireDefault(require("../components/EditAccessoryComponent"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Services = require("../common_features/utility/Services");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _lodash = _interopRequireDefault(require("lodash"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditAccessory = () => {
  const {
    selectedAccessory
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [warningModal, setWarningModal] = (0, _react.useState)(false);
  const [errorModal, setErrorModal] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)("");
  const [isUpdating, setIsUpdating] = (0, _react.useState)(false);
  const [saveErrorModal, setSaveErrorModal] = (0, _react.useState)(false);
  const dispatch = (0, _reactRedux.useDispatch)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const isPartial = selectedSystems.isComplete;
  const warningModalData = {
    variant: "warning-modal",
    displayModal: warningModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Warning",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "Removing the accessory will remove the view from the system dashboard.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleFailureContinue(),
    // crossIconAction: () => handleFailureModal(!openErrorModal),
    negativeAvtion: () => handlefailureCancel()
  };
  const deleteErrorModalData = {
    variant: "error-modal",
    displayModal: errorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Error",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "The requested action did not complete successfully, please try again.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Retry",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleErrorRetry(),
    // crossIconAction: () => handleFailureModal(!openErrorModal),
    negativeAvtion: () => handleErrorCancel()
  };
  const handleErrorRetry = () => {
    setErrorModal(false);
    handleFailureContinue();
  };
  const handleErrorCancel = () => {
    setErrorModal(false);
  };
  const handleFailureContinue = async () => {
    setIsUpdating(true);
    setWarningModal(false);
    let systemID = selectedAccessory.systemId;
    let accessoryID = selectedAccessory.refAppId;
    try {
      const response = await (0, _Services.deleteAccessory)(systemID, accessoryID);
      setIsUpdating(false);
      if (response) {
        navigate(-1);
      }
    } catch (error) {
      setIsUpdating(false);
      setErrorModal(true);
    }
  };
  const handlefailureCancel = () => {
    setWarningModal(false);
  };
  const dateChange = date => {
    setValue(date);
  };
  const handleBack = () => {
    navigate(-1);
  };
  const handleRemoveBtn = async () => {
    setWarningModal(true);
  };
  {
    console.log(selectedAccessory, "selectedAccessory");
  }
  const handleSaveBtn = async () => {
    setIsUpdating(true);
    setErrorModal(false);
    const formatedDate = "".concat(value === null || value === void 0 ? void 0 : value.getFullYear(), "-").concat(((value === null || value === void 0 ? void 0 : value.getMonth()) + 1).toString().length === 1 ? "0".concat((value === null || value === void 0 ? void 0 : value.getMonth()) + 1) : (value === null || value === void 0 ? void 0 : value.getMonth()) + 1, "-").concat((value === null || value === void 0 ? void 0 : value.getDate().toString().length) === 1 ? "0".concat(value === null || value === void 0 ? void 0 : value.getDate()) : value === null || value === void 0 ? void 0 : value.getDate());
    const data = {
      orgId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId,
      systemId: selectedAccessory.systemId,
      systemReferences: [{
        refAppId: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppId,
        refAppInstallationDate: formatedDate,
        refAppName: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppName,
        refAppType: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppType
      }]
    };
    setIsUpdating(false);
    const date = new Date(selectedAccessory.refAppInstallationDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const initialDate = "".concat(year, "-").concat(month, "-").concat(day);
    dispatch((0, _systemsReducer.imageData)([]));
    navigate(_RoutePath.default.imageUpload.useLink, {
      state: {
        fromScreen: 'editAccessory',
        filterDetail: selectedAccessory,
        navHeading: 'Edit Accessory',
        changesFlag: !_lodash.default.isEqual(initialDate, formatedDate),
        refAppId: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppId
      }
    });
  };
  (0, _react.useEffect)(() => {
    if (!value && selectedAccessory) {
      setValue(new Date(selectedAccessory.refAppInstallationDate));
    }
  }, [value, selectedAccessory]);
  const getWarningModal = () => {
    return errorModal ? deleteErrorModalData : "";
  };
  return /*#__PURE__*/_react.default.createElement(_EditAccessoryComponent.default, {
    handleBack: handleBack,
    leftArrow: _index.default.leftArrow.default,
    backNavigationScreen: "System Dashboard",
    headerText: "Edit Accessory",
    pname: "".concat(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber, ">").concat(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppName),
    subContent: "Are you making any changes to this accessory?",
    inputLabel: "Installation  Date",
    dateChange: dateChange,
    saveBtnTitle: "Save",
    saveBtnClick: handleSaveBtn,
    saveBtnDisabled: false,
    removeSensorButtonText: "Remove Accessory",
    removeBtnClick: handleRemoveBtn,
    removeBtnDisabled: false,
    edit: false,
    warningModal: warningModal,
    value: value,
    warningModalData: warningModal ? warningModalData : getWarningModal(),
    errorModal: errorModal,
    isUpdating: isUpdating,
    pageNumberNotShow: true,
    isPartial: isPartial
  });
};
var _default = exports.default = EditAccessory;